
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-gpk/pejabat-penilai-kinerja/perencanaan/belum-diajukan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-gpk/pejabat-penilai-kinerja/perencanaan/belum-diajukan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-gpk/pejabat-penilai-kinerja/perencanaan/belum-diajukan"])
      });
    }
  